import React from 'react'
import image from '../../../../assets/images/trend.png'

function CardStatisticsReport({width_100,title,number,width}) {
    return (
        <div className={`${width_100 && 'w-report-100'} ${width && 'w-report'} one-card-statistics-report-account`}  >
            <div className='statistics-report-account-info' >
                <span className='statistics-report-account-info-title'>{title}</span>
                <span className='statistics-report-account-info-num'>{number}</span>
            </div>
            <img src={image} width={'20px'} height={'20px'} />
        </div>
    )
}

export default CardStatisticsReport